<template>
    <div class="form-wrapper">
        <CustomFormItem
            v-for="(item, idx) in comps"
            :key="item.uId || idx"
            :value="datas[item.props.name]"
            :formvalue="datas"
            :widget="item"
            :labelProps="commChildLabelProps"
            :verifyInfo="verifyInfo[item.props.name] || {}"
            :rules="rules[item.props.name] || []"
            :validation="validation"
            :inline="widget.props && widget.props.inline"
            @change="changeHandler(item, $event)"
            @verify="verifyHandler(item, $event)"
        />
    </div>
</template>

<script>
export default {
    name: "Form",
    components: {
        CustomFormItem: () => import("./FormItem.vue")
    },
    props: ["value", "widget", "verifyInfo", "rules", "validation"],
    computed: {
        datas() {
            return this.value || {};
        },
        comps() {
            const { children = [] } = this.widget;
            const filteredValue = { ...this.datas };
            let isValueChange = false;

            const filtered = children.filter(child => {
                if (child.props.beforeCreated) {
                    const action = child.props.beforeCreated(this.value || {});
                    if (action === "hide" || action.id === "hide") {
                        if (filteredValue[child.props.name] != null) {
                            isValueChange = true;
                            delete filteredValue[child.props.name];
                        }
                        return false;
                    }
                }
                return true;
            });
            if (isValueChange) {
                // eslint-disable-next-line
                setTimeout(() => this.$emit('change', filteredValue), 15);
            }
            return filtered;
        },
        commChildLabelProps() {
            const { props } = this.widget;
            const ret = {};
            if (props.subItemLabelPosition) {
                ret.labelPosition = props.subItemLabelPosition;
            }
            if (props.subItemLabelWidth) {
                ret.labelWidth = props.subItemLabelWidth;
            }
            return ret;
        }
    },
    methods: {
        changeHandler(item, newItemData) {
            const newData = { ...this.datas, [item.props.name]: newItemData };
            this.relatedCheck(item, newData);
            this.$emit("change", newData);
        },
        relatedCheck(changedItem, newForm) {
            const { children = [] } = this.widget;
            if (changedItem.props.trigger) {
                changedItem.props.trigger.forEach(propName => {
                    children.some(child => {
                        if (child.props.name !== propName) {
                            return false;
                        }
                        if (child.props.triggerAction) {
                            const triggerFunc = child.props.triggerAction;
                            newForm[propName] = triggerFunc();
                        }
                        return true;
                    });
                });
            }
        },
        verifyHandler(item, info) {
            const newVerifyInfo = { ...this.verifyInfo };
            newVerifyInfo[item.props.name] = info;
            this.$emit("verify", newVerifyInfo);
        }
    }
};
</script>

<style scoped lang="less">
.form-wrapper {
    //
    display: flex;
    // align-items: center;
}
</style>
